/*
 * File: Forbidden.tsx
 * Project: little-murrary-sparkles
 * -----
 * Last Modified: 15 Jun 2022 4:41:27 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

/* eslint-disable @typescript-eslint/no-explicit-any */

import '../common/styles/forbidden.css';

export const Forbidden = (): JSX.Element => {
  const root: any = document?.documentElement;
  const eyef: any = document?.getElementById('eyef');
  let cx: any = document?.getElementById('eyef')?.getAttribute('cx');
  let cy: any = document?.getElementById('eyef')?.getAttribute('cy');

  document?.addEventListener('mousemove', (evt) => {
    const x: any = evt.clientX / window.innerWidth;
    const y: any = evt.clientY / window.innerHeight;

    root.style?.setProperty('--mouse-x', x);
    root.style?.setProperty('--mouse-y', y);

    if (x && y) {
      cx = 115 + 30 * x;
      cy = 50 + 30 * y;
      eyef?.setAttribute('cx', cx);
      eyef?.setAttribute('cy', cy);
    }
  });

  document.addEventListener('touchmove', (touchHandler) => {
    const x = touchHandler.touches[0].clientX / window.innerWidth;
    const y = touchHandler.touches[0].clientY / window.innerHeight;

    root.style.setProperty('--mouse-x', x);
    root.style.setProperty('--mouse-y', y);
  });

  return (
    <div className="forbidden-container">
      <div style={{ maxWidth: 1920 }}>
        <svg className="robot" xmlns="http://www.w3.org/2000/svg" id="robot-error" viewBox="0 0 260 118.9">
          <defs>
            <clipPath id="white-clip">
              <circle id="white-eye" fill="#cacaca" cx="130" cy="65" r="20" />{' '}
            </clipPath>
            <text id="text-s" className="error-text" y="106">
              {' '}
              403{' '}
            </text>
          </defs>
          <path className="alarm" fill="#e62326" d="M120.9 19.6V9.1c0-5 4.1-9.1 9.1-9.1h0c5 0 9.1 4.1 9.1 9.1v10.6" />
          <use xlinkHref="#text-s" x="-0.5px" y="-1px" fill="black"></use>
          <use xlinkHref="#text-s" fill="#2b2b2b"></use>
          <g id="robot">
            <g id="eye-wrap">
              <use xlinkHref="#white-eye"></use>
              <circle id="eyef" className="eye" clipPath="url(#white-clip)" fill="#000" stroke="#2aa7cc" strokeWidth="2" strokeMiterlimit="10" cx="130" cy="65" r="11" />
              <ellipse id="white-eye" fill="#2b2b2b" cx="130" cy="40" rx="18" ry="12" />
            </g>
            <circle className="lightblue" cx="105" cy="32" r="2.5" id="tornillo" />
            <use xlinkHref="#tornillo" x="50"></use>
            <use xlinkHref="#tornillo" x="50" y="60"></use>
            <use xlinkHref="#tornillo" y="60"></use>
          </g>
        </svg>
        <h1 style={{ color: 'white' }}>You do not have access to this resource.</h1>
        <h2 style={{ color: 'white' }}>
          Go{' '}
          <a className="forbidden-link" href="/" rel="noreferrer">
            Home!
          </a>
        </h2>
      </div>
    </div>
  );
};
